<template>
  <div>
    <v-layout wrap align-center>
      <v-flex d-flex>
        <h3 class="primary-color text-center">Veja as características básicas do projeto:</h3>
      </v-flex>
    </v-layout>
    <v-layout wrap align-center>
      <v-flex d-flex>
        <v-card class="grey lighten-4" flat>
          <v-img class="my-3 mx-auto" :src="thunderImage" aspect-ratio="2" width="10rem" contain></v-img>
          <p class="text-center card-value">{{parseFloat(caracteristicasBasicas.generatorCapacity).toFixed(2)}} KwP</p>
          <p class="text-center card-info mb-3">Potência mínima</p>
        </v-card>
      </v-flex>
      <v-flex d-flex>
        <v-card class="grey lighten-4" flat>
          <v-img class="my-3 mx-auto" :src="areaImage" aspect-ratio="2" width="10rem" contain></v-img>
          <p class="text-center card-value">{{parseFloat(caracteristicasBasicas.area).toFixed(2) }} m²</p>
          <p class="text-center card-info mb-3">Área mínima ocupada pelo sistema</p>
        </v-card>
      </v-flex>
      <v-flex d-flex>
        <v-card class="grey lighten-4" flat>
          <v-img class="my-3 mx-auto" :src="weightImage" aspect-ratio="2" width="10rem" contain></v-img>
          <p class="text-center card-value">{{parseFloat(caracteristicasBasicas.weight).toFixed(2)}} Kg</p>
          <p class="text-center card-info mb-3">Peso sobre o telhado</p>
        </v-card>
      </v-flex>
    </v-layout>
    <div class="text-center my-3">
      <p
        class="content-grey"
      >Com essas informações já é possível identificar as melhores opções de gerador.</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProjectBasicCharacteristics',
  computed: {
    ...mapGetters(['caracteristicasBasicas'])
  },
  data() {
    return {
      thunderImage: require('./icons/thunder.svg'),
      areaImage: require('./icons/area.svg'),
      weightImage: require('./icons/weight.svg')
    }
  }
}
</script>

<style scoped>
</style>
